/**
 * AI生成プロフィール入力ステップ（PlayerIconEditor専用）
 */
import { GenerationStatus } from "features/generation/types";
import { GenderStep } from "./GenderStep";
import { BirthdayStep } from "./BirthdayStep";
import { FavoritesStep } from "./FavoritesStep";
import { ProfileSubStepBar } from "../components";
import { IconPreviewStep } from "./IconPreviewStep";
import { EditorProfileState, ProfileSubStep, FavoritesSubStep } from "../types";

interface ProfileAIStepProps {
  state: EditorProfileState;
  updateState: (updates: Partial<EditorProfileState>) => void;
  currentSubStep: ProfileSubStep;
  generationStatus: GenerationStatus;
  generationProgress: number;
  generatedImage: string | null;
  partialImage: string | null;
  favoritesSubStep: FavoritesSubStep;
  onSubStepNext: () => void;
  onSubStepClick: (
    targetSubStep: ProfileSubStep,
    targetFavoritesSubStep?: FavoritesSubStep,
  ) => void;
  // 追加プロンプト関連
  additionalPrompt?: string;
  onAdditionalPromptChange?: (prompt: string) => void;
  onRegenerate?: () => void;
  // サブステップバーの表示制御
  hideSubStepBar?: boolean;
  completedStepIds?: string[];
  isGenerating?: boolean;
}

export const ProfileAIStep = ({
  state,
  updateState,
  currentSubStep,
  generationStatus,
  generationProgress,
  generatedImage,
  partialImage,
  favoritesSubStep,
  onSubStepClick,
  additionalPrompt,
  onAdditionalPromptChange,
  onRegenerate,
  hideSubStepBar = false,
  completedStepIds,
  isGenerating,
}: ProfileAIStepProps) => {
  const renderContent = () => {
    switch (currentSubStep) {
      case ProfileSubStep.GENDER:
        return <GenderStep state={state} updateState={updateState} />;
      case ProfileSubStep.BIRTHDAY:
        return <BirthdayStep state={state} updateState={updateState} />;
      case ProfileSubStep.FAVORITES:
        return (
          <FavoritesStep
            state={state}
            updateState={updateState}
            favoritesSubStep={favoritesSubStep}
          />
        );
      case ProfileSubStep.ICON_PREVIEW:
        return (
          <IconPreviewStep
            status={generationStatus}
            progress={generationProgress}
            generatedImage={generatedImage}
            partialImage={partialImage}
            additionalPrompt={additionalPrompt}
            onAdditionalPromptChange={onAdditionalPromptChange}
            onRegenerate={onRegenerate}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex-row-el w-full h-full">
      {/* サブステップ進捗バー（左側） - hideSubStepBarがtrueなら非表示 */}
      {!hideSubStepBar && (
        <ProfileSubStepBar
          currentSubStep={currentSubStep}
          favoritesSubStep={favoritesSubStep}
          onStepClick={onSubStepClick}
          completedStepIds={completedStepIds}
          isGenerating={isGenerating}
        />
      )}

      {/* コンテンツ（右側・中央揃え） */}
      <div className="flex-col-el flex-center flex-1 min-h-0">{renderContent()}</div>
    </div>
  );
};
